const dialogs = []

export default dialogs
